// DEV ONLY: 从 URL hash #__devsync= 读取 base64(JSON) 并写入 localStorage
// 必须作为 main.ts 的第一个 import，以保证在 i18nInit / store 等读取 localStorage 之前完成写入
// 生产环境 no-op (hostname !== 'localhost')
try {
  if (typeof window !== 'undefined' && window.location.hostname === 'localhost') {
    const m = window.location.hash.match(/__devsync=([^&]+)/);
    if (m) {
      const data = JSON.parse(decodeURIComponent(atob(m[1])));
      Object.entries(data).forEach(([k, v]) => {
        if (typeof v === 'string') localStorage.setItem(k, v);
      });
      history.replaceState(null, '', window.location.pathname + window.location.search);
    }
  }
} catch (e) {
  // eslint-disable-next-line no-console
  console.warn('[devsync] failed:', e);
}

export {};
